import { createSlice } from "@reduxjs/toolkit";
import { foundationDetailsService } from "Services/FoundationDetailsService";

export const initialState = {
    originalValues: {},
    foundationName: {
        value: '',
        error: ''
    },
    registeredName: {
        value: '',
        error: ''
    },
    otherName: {
        value: '',
        error: ''
    },
    phoneNumber: {
        value: '',
        error: ''
    },
    email: {
        value: '',
        error: ''
    },
    site: {
        value: '',
        error: ''
    },
    address: {
        value: '',
        error: ''
    },
    complement: {
        value: '',
        error: ''
    },
    city: {
        value: '',
        error: ''
    },
    state: {
        value: '',
        error: ''
    },
    zipCode: {
        value: '',
        error: ''
    },
    ein: {
        value: '',
        error: ''
    },
    isDaf: {
        value: 'false',
        error: ''
    },
    nteeCode: {
        value: '',
        error: ''
    },
    nteeTitle: {
        value: '',
        error: ''
    },
    nteeDescription: {
        value: '',
        error: ''
    },
    removeFunder: {
        value: false,
        error: ''
    }
};

const updateFoundationSlice = createSlice({
    name: "update-foundation-us",
    initialState,
    reducers: {
        handleChange: (state, action) => {
            state[action.payload.field].error = '';
            state[action.payload.field].value = action.payload.value;            
        },
        handleModelErrors: (state, action) => {
            Object.entries(action.payload).forEach(([field, errors]) => {
                state[field].error = errors[0];
            });
        },

    },
    extraReducers: (builder) => {
        builder.addMatcher(
            foundationDetailsService.endpoints.getFunderForEdit.matchFulfilled, (state, action) => {
                const funder = action.payload;

                const mappedValues = {
                    foundationName: funder.foundationName ?? '',
                    phoneNumber: funder.phone ?? '',
                    email: funder.email ?? '',
                    site: funder.site ?? '',
                    address: funder.address ?? '',
                    complement: funder.complement ?? '',
                    city: funder.city ?? '',
                    state: funder.stateOrProvince ?? '',
                    zipCode: funder.zipOrPostalCode ?? '',
                    isDaf: funder.isDaf ?? 'false',
                    nteeCode: funder.nteeCode ?? '',
                    nteeTitle: funder.nteeTitle ?? '',
                    nteeDescription: funder.nteeDescription ?? '',
                };

                Object.entries(mappedValues).forEach(([field, value]) => {
                    state[field].value = value;
                    state[field].error = '';
                });

                state.ein.value = funder.profileId ?? '';
                state.removeFunder.value = false;
                state.originalValues = mappedValues;
            }
        )
    },
});

export const {
    handleChange,
    handleModelErrors,
} = updateFoundationSlice.actions;

export default updateFoundationSlice.reducer;